import BaseService from './BaseService';
import AuthorizationService from '../services/AuthorizationService';
import LocalStorageService from '../services/LocalStorageService';

class CatalogManagementService extends BaseService {

	constructor() {
		super();
		this.serviceUrl = "/api/rest/catalogManagement";
	}

	listOffers() {
		let url = this.serviceUrl + '/productSpecification';
		const currentCustomer = LocalStorageService.getCurrentCustomer();
		if (AuthorizationService.auth.authenticated && currentCustomer != null) {
			return this.opencellAPI.callApi(url);
		} else {
			return this.opencellAPI_selfWS.callApi(url);
		}
	}

}

const catalogManagementService = new CatalogManagementService();

export default catalogManagementService;


// WEBPACK FOOTER //
// ./src/opencell/services/CatalogManagementService.js